<template>
  <div class="banner-box-2500-container">
    <div
      class="relative new-mode-header"
      :class="titleAlignmentClass"
      v-if="item?.topLanguageMap && item?.topLanguageMap?.title"
    >
      <div>
        <div class="title-left">
          <!-- <img
            class="title-icon"
            v-if="$utils.lang_data(lang, item.list[0] && item.list[0], 'langInfoObj')?.icon"
            :src="$utils.returnImgUrl($utils.lang_data(lang, item.list[0], 'langInfoObj')?.icon)"
            alt
          /> -->
          <span class="title">{{ item?.topLanguageMap?.title }}</span>
        </div>
        <!-- 副标题 -->
        <div class="title_sub" v-if="item?.topLanguageMap?.subTitle">{{ item?.topLanguageMap?.subTitle }}</div>
      </div>
    </div>
    <div
      class="banner-box mt10"
      id="banner-box-id"
      :class="{
        'banner-box-pc mt20': !getIsMobile,
        mt10: getIsMobile,
        'progress-point': showProgress,
        ['rotationTime' + rotationTime]: rotationTime,
      }"
    >
      <!-- :type="isCard ? 'card' : ''" -->
      <div v-if="getIsMobile">
        <el-carousel
          class="mobileBox"
          ref="slideCarousel"
          :loop="true"
          :autoplay="true"
          :interval="rotationTime"
          :indicator-position="(showIndicator || showProgress) && !showArrow ? '' : 'none'"
          id="h5_carousel"
          :height="bannerH5 + 'px'"
        >
          <el-carousel-item
            v-for="(item, i) in list"
            :key="'h5_' + i"
            :class="{
              'h5-gradient': gradientH5,
            }"
          >
            <el-skeleton :loading="skeletonLoading" animated :throttle="0">
              <template slot="template">
                <el-skeleton-item variant="image" style="width: 100%; height: 150px" />
              </template>
              <template :style="`width: 100%; height: ${bannerH5}px`">
                <div
                  class="c-img-box h-img-box"
                  v-exposure="{ eid: item.eid, jump_value: item.jump }"
                  :data-id="item.eid"
                  @click="btnCilck(item, i)"
                >
                  <!-- <div class="serve-time">( UTC-4 ) {{ bTime }}</div> -->
                  <img
                    @load="imgLoad"
                    ref="bannerH5"
                    :src="$utils.returnImgUrl(getImgUrl(item, 'h5Img'))"
                    alt=""
                    style="width: 100%"
                  />
                </div>
              </template>
            </el-skeleton>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- type="card" -->
      <div class="relative" v-if="!getIsMobile">
        <div>
          <template v-if="thumbnail">
            <el-row :gutter="20">
              <el-col :span="18">
                <el-carousel
                  ref="slideCarouselPcVertical"
                  :loop="true"
                  :autoplay="true"
                  direction="vertical"
                  arrow="never"
                  indicator-position="none"
                  :interval="rotationTime"
                  @change="onChange"
                  id="pc_carousel"
                  class="pc_carousel_vertical"
                  :height="bannerPC + 'px'"
                >
                  <el-carousel-item v-for="(item, index) in listFormat" :key="item.sid + index">
                    <el-skeleton :loading="skeletonLoading" animated :throttle="0">
                      <template slot="template">
                        <el-skeleton-item variant="image" :style="`width: 100%; height: ${bannerPC}px`" />
                      </template>
                      <template style="width: 100%; height: 100%">
                        <div
                          class="c-img-box h-img-box"
                          v-exposure="{ eid: item.eid, jump_value: item.jump }"
                          :data-id="item.eid"
                          @click="btnCilck(item, index)"
                        >
                          <img
                            class="carousel-img"
                            @load="imgLoad"
                            ref="bannerPC"
                            :src="$utils.returnImgUrl(getImgUrl(item, 'pcImg'))"
                            alt
                            style="display: block"
                          />
                        </div>
                      </template>
                    </el-skeleton>
                  </el-carousel-item>
                </el-carousel>
              </el-col>
              <el-col :span="6">
                <div class="indicators-container" :style="`height: ${bannerPC}px; overflow: hidden;`">
                  <div class="inner" :style="indicatorsTransform">
                    <div
                      class="indicators-item"
                      v-for="(item, index) in listFormat"
                      :key="item.sid + index"
                      :class="{ 'active-indicator': index === currentIndex }"
                      @click="setActive(index)"
                    >
                      <img class="indicators-img" :src="$utils.returnImgUrl(getImgUrl(item, 'pcImg'))" alt="" />
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </template>
          <template v-else>
            <el-carousel
              ref="slideCarouselPc"
              :loop="true"
              :autoplay="true"
              :arrow="showArrow ? 'always' : 'never'"
              :interval="rotationTime"
              :indicator-position="(showIndicator || showProgress) && !showArrow ? '' : 'none'"
              :type="isCard ? 'card' : ''"
              id="pc_carousel"
              :height="bannerPC + 'px'"
            >
              <el-carousel-item
                v-for="(item, i) in listFormat"
                :key="'pc_' + i"
                :class="{
                  'pc-gradient': gradient,
                }"
              >
                <el-skeleton :loading="skeletonLoading" animated :throttle="0">
                  <template slot="template">
                    <el-skeleton-item variant="image" :style="`width: 100%; height: ${bannerPC}px`" />
                  </template>
                  <!-- <template style="width: 100%; height: 100%"> -->
                  <div class="c-img-box h-img-box">
                    <template v-if="tiliTwo || tiliOneThree">
                      <el-row :gutter="20">
                        <el-col
                          :span="tiliTwo ? 12 : 8"
                          v-for="(child, index) in item"
                          :key="child.sid"
                          v-exposure="{ eid: child.eid, jump_value: child.jump }"
                          :data-id="child.eid"
                        >
                          <img
                            @click="btnCilck(child, index)"
                            class="carousel-img carousel-img-child"
                            @load="imgLoad"
                            ref="bannerPC"
                            :src="$utils.returnImgUrl(getImgUrl(child, 'pcImg'))"
                            alt
                            style="display: block"
                          />
                        </el-col>
                      </el-row>
                    </template>

                    <img
                      v-else
                      class="carousel-img"
                      @load="imgLoad"
                      ref="bannerPC"
                      @click="btnCilck(item, i)"
                      :src="$utils.returnImgUrl(getImgUrl(item, 'pcImg'))"
                      alt
                      style="display: block"
                      v-exposure="{ eid: item.eid, jump_value: item.jump }"
                      :data-id="item.eid"
                    />
                  </div>
                  <!-- </template> -->
                </el-skeleton>
              </el-carousel-item>
            </el-carousel>
          </template>
        </div>
        <!-- <img v-if="listPc && listPc.length > 1" @click="turnLeft" :src="left2" alt="" class="el-icon-arrow-left" />
        <img v-if="listPc && listPc.length > 1" @click="turnRight" :src="right2" alt="" class="el-icon-arrow-right" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import hBanner from "@/lobby_common/mixins_components/banner/h-banner.js";
export default {
  props: [],
  mixins: [hBanner],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.banner-box {
  .el-carousel__item {
    &.pc-gradient,
    &.h5-gradient {
      transform: none !important;
      opacity: 0;
      transition: opacity 0.3s;
      &.is-active {
        opacity: 1;
        z-index: 10;
      }
    }
  }
  .h-img-box.c-img-box {
    height: 100%;
    width: 100%;
    border-radius: 0;
    position: relative;
    img {
      height: 100%;
      border-radius: var(--radius-300);
      @media (max-width: 768px) {
        border-radius: var(--radius-301);
      }
    }
    .serve-time {
      position: absolute;
      right: 4px;
      top: 3px;
      padding: 0 8px;
      line-height: 20px;
      font-size: 12px;
      background-color: var(--background-1000);
      color: var(--font-color-100);
      border-radius: 4px;
    }
  }
}
</style>

<style lang="scss" scoped>
.mobileBox {
  min-height: 140px;
  overflow: hidden;
}
.banner-box {
  margin-bottom: 2px;
  overflow: hidden;
}

.hidden-sm-and-up {
  ::v-deep .el-carousel__indicators {
    left: 50%;
    bottom: 5px;
    transform: translateX(-50%);
  }
}
::v-deep .el-carousel__indicators {
  &.el-carousel__indicators--horizontal {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .el-carousel__indicator {
    .el-carousel__button {
      width: 15px;
    }
  }
}
.c-img-box {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  background-size: cover;
  overflow: hidden;
  border-radius: var(--radius-300);
  cursor: pointer;
  @media (max-width: 768px) {
    border-radius: var(--radius-301);
  }

  .carousel-img {
    display: inline-block;
    max-width: 100%;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    border-radius: var(--radius-300);
    @media (max-width: 768px) {
      border-radius: var(--radius-301);
    }
  }

  .txt {
    position: absolute;
    left: 10%;
    bottom: 10%;
  }
}
::v-deep .el-carousel__container {
  @media (max-width: 768px) {
    overflow: hidden;
    border-radius: var(--radius-301);
  }
}
#pc_carousel ::v-deep .el-carousel__container {
  border-radius: 5px;
  overflow: hidden;
}
#pc_carousel .el-carousel__item--card {
  width: 70%;
  margin-left: -10%;
  opacity: 0.2;
  filter: alpha(opacity=20);
}

#pc_carousel .is-active {
  opacity: 1 !important;
  filter: alpha(opacity=100) !important;
}

#pc_carousel ::v-deep .el-carousel__indicators {
  position: relative !important;
  top: 0px !important;
  padding-top: 10px;
  transform: translateX(-50%) !important;
}
#h5_carousel ::v-deep .el-carousel__indicators {
  position: relative !important;
  top: 0px !important;
  padding-top: 5px;
  transform: translateX(-50%) !important;
}
#pc_carousel.pc_carousel_vertical ::v-deep .el-carousel__indicators {
  position: absolute !important;
  padding-top: unset !important;
  right: 0 !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}

#pc_carousel .c-img-box {
  width: 100%;
  height: 100%;
  // max-width: 900px;
}
.indicators-container {
  position: relative;
  .inner {
    transition: transform linear 0.3s;
  }
  .indicators-item {
    position: relative;
    margin-top: 5px;
    height: calc((100% - 20px) / 3);
    width: 100%;
    border-radius: 5px;
    overflow: hidden;
    opacity: 0.5;
    transition: opacity ease 0.3s;
    cursor: pointer;
    background-size: cover;
    &.active-indicator {
      opacity: 1;
    }
    &:first-child {
      margin-top: 0;
    }
  }
  .indicators-img {
    width: 100%;
    height: 100%;
  }
}
@media (min-width: 1310px) {
  #pc_carousel .el-carousel__item--card {
    margin-left: calc(-10% + 12px);
  }
}
div.banner-box-pc {
  overflow: visible;
  ::v-deep .el-carousel__indicators {
    .el-carousel__indicator {
      position: relative;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      padding: 0;
      margin: 0 5px;
      &.is-active {
        width: 25px;
        .el-carousel__button {
          width: 25px;
        }
      }

      .el-carousel__button {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 10px;
        height: 10px;
        border-radius: 6px;
        background-color: transparent;
        border-color: transparent;
        background: var(--font-color-900);
      }

      button {
        background: var(--button-400);
      }

      &.is-active button {
        background: var(--button-700);
      }
    }

    &.el-carousel__indicators--outside {
      padding-top: 12px;
    }
  }
}
.el-icon-arrow-left {
  width: 30px;
  position: absolute;
  left: -35px;
  top: 50%;
  margin-top: -30px;
  cursor: pointer;
  z-index: 1;
  border-radius: 5px;
}
.el-icon-arrow-right {
  width: 30px;
  position: absolute;
  right: -35px;
  top: 50%;
  margin-top: -30px;
  cursor: pointer;
  z-index: 1;
  border-radius: 5px;
}
.isOnly {
  margin: 0 33.33%;
}
.carousel-img {
  border-radius: 5px;
}
::v-deep .el-carousel__arrow {
  z-index: 99;
}

#banner-box-id.banner-box.progress-point {
  .mobileBox {
    ::v-deep .el-carousel__button {
      height: 6px;
      border-radius: 3px;
    }
  }
  &.banner-box-pc {
    ::v-deep .el-carousel__button {
      transform: translate(0, -50%);
    }
  }
  ::v-deep .el-carousel__indicator--horizontal {
    padding: 0 4px;
  }
  ::v-deep .el-carousel__indicators .el-carousel__indicator {
    &.is-active {
      width: 50px !important;
      background: var(--background-400);
      border-radius: 5px;
      position: relative;
      overflow: hidden;
      .el-carousel__button {
        position: absolute;
        left: 0;
        height: 100%;
        width: 100%;
        transform-origin: left;
      }
    }
  }
  &.rotationTime1000 {
    ::v-deep .el-carousel__indicators .el-carousel__indicator.is-active .el-carousel__button {
      animation: widthGrow 1s forwards;
    }
  }
  &.rotationTime2000 {
    ::v-deep .el-carousel__indicators .el-carousel__indicator.is-active .el-carousel__button {
      animation: widthGrow 2s forwards;
    }
  }
  &.rotationTime3000 {
    ::v-deep .el-carousel__indicators .el-carousel__indicator.is-active .el-carousel__button {
      animation: widthGrow 3s forwards;
    }
  }
  &.rotationTime4000 {
    ::v-deep .el-carousel__indicators .el-carousel__indicator.is-active .el-carousel__button {
      animation: widthGrow 4s forwards;
    }
  }
  &.rotationTime5000 {
    ::v-deep .el-carousel__indicators .el-carousel__indicator.is-active .el-carousel__button {
      animation: widthGrow 5s forwards;
    }
  }
  &.rotationTime6000 {
    ::v-deep .el-carousel__indicators .el-carousel__indicator.is-active .el-carousel__button {
      animation: widthGrow 6s forwards;
    }
  }
  &.rotationTime7000 {
    ::v-deep .el-carousel__indicators .el-carousel__indicator.is-active .el-carousel__button {
      animation: widthGrow 7s forwards;
    }
  }
  &.rotationTime8000 {
    ::v-deep .el-carousel__indicators .el-carousel__indicator.is-active .el-carousel__button {
      animation: widthGrow 8s forwards;
    }
  }
  &.rotationTime9000 {
    ::v-deep .el-carousel__indicators .el-carousel__indicator.is-active .el-carousel__button {
      animation: widthGrow 9s forwards;
    }
  }
  &.rotationTime10000 {
    ::v-deep .el-carousel__indicators .el-carousel__indicator.is-active .el-carousel__button {
      animation: widthGrow 10s forwards;
    }
  }
}
@keyframes widthGrow {
  from {
    width: 10%;
  }
  to {
    width: 100%;
  }
}
</style>
